import React, { useEffect, useRef } from 'react';
import marqueeimg from '../Assets/images/merchonchainmarquee.svg';
import bgVideo1 from '../Assets/images/gift.mp4';
import bgVideo2 from '../Assets/images/gift2.mp4';

import buildoverlay from '../Assets/images/build-overlay.png';
import buildtext from '../Assets/images/build-text.png';
import buildy from '../Assets/images/buildy.png';

import products from '../Assets/Data/products.json';

// Dynamically load images from the folder
const images = require.context('../Assets/images', false, /\.(png|jpe?g|svg)$/);

// Helper function to preload images
const preloadImages = (srcArray) => {
  srcArray.forEach(src => {
    const img = new Image();
    img.src = src;
  });
};

const Marquee = () => {
  const overlayRef = useRef(null);

  // Preload images on component mount
  useEffect(() => {
    const staticImages = [marqueeimg, buildoverlay, buildtext, buildy];
    preloadImages(staticImages);

    const productImagePaths = products.map((item) => images(`./${item.id}`).default);
    preloadImages(productImagePaths);
  }, []);

  // Intersection observer to adjust overlay height on mobile
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const overlayElement = overlayRef.current;

    if (!isMobile || !overlayElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          overlayElement.style.height = '350px';
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(overlayElement);

    return () => {
      if (overlayElement) {
        observer.unobserve(overlayElement);
      }
    };
  }, []);

  return (
    <div>
      <div className="marquee-container">
        <div className="marquee">
          <div className="marquee-track">
            {Array(8).fill().map((_, idx) => (
              <img key={idx} src={marqueeimg} alt="Merch On Chain Logo" />
            ))}
          </div>
        </div>
      </div>

      <div className="text-center mb-3">
        <h1 className="text-xxl white-text">
          <span className="text-xxxl green-text">MERCH </span> FOR EVERY MISSION
        </h1>

        <div className="features-wrapper d-flex align-center justify-center mobile-flex">
          {['T E A M', 'E V E N T', 'C O M M U N I T Y'].map((label, i) => (
            <div className="feature-container" key={i}>
              <p className="white-text">{label} <span className="ml-2">&#9989;</span></p>
            </div>
          ))}
        </div>

        <div className="d-flex prods justify-center mobile-flex">
          <div className="build-box">
            <div className="bulid-container">
              <img src={buildtext} alt="build-text" style={{ width: '100%' }} />
              <img
                ref={overlayRef}
                src={buildoverlay}
                className="overlay"
                alt="overlay"
              />
            </div>
          </div>

          <div className="tp-cont">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="bg-video desktop-only"
              style={{ height: '300px' }}
            >
              <source src={bgVideo1} type="video/mp4" />
            </video>
            <video
              autoPlay
              loop
              muted
              playsInline
              className="bg-video mobile-only"
              style={{ height: '300px' }}
            >
              <source src={bgVideo2} type="video/mp4" />
            </video>
            <div className="blue-cont">
              <h2 className="white-text text-left p-2">
                Order in bulk and customise your merch, your way.
              </h2>
            </div>
          </div>

          <div>
            <img src={buildy} style={{ height: '510px' }} alt="build" />
          </div>
        </div>
      </div>

      <div className="product-scroller-wrapper">
        <h1 className="text-xxl pink-gradient text-center">
          Ideate, Create and Deliver Merch That Hits
        </h1>
        <h4 className="text-xl white-text text-center">
          Choose what you need, we'll handle rest!
        </h4>

        <div className="marquee-container-products">
          <div className="marquee-products">
            <div className="marquee-track">
              {[...products, ...products].map((item, index) => (
                <img
                  key={index}
                  src={images(`./${item.id}`)}
                  alt={`item-${index}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marquee;
